/**
 * Module-level cache for TSAccountProtection SDK initialisation errors.
 *
 * The SDK's onError fires at app boot — before the user is authenticated and
 * before any API call can be made. Rather than discarding the error or hitting
 * an unauthenticated endpoint, we park it here. When executeTransmitRisk is
 * later called (which implies a login or action attempt is in progress), it
 * reads this cache, includes the original init error in the riskRecord payload,
 * and then clears it.
 */

interface TransmitInitError {
  reason: string;
  stack: string;
}

let cached: TransmitInitError | null = null;

export const setTransmitInitError = (error: TransmitInitError): void => {
  cached = error;
};

export const getTransmitInitError = (): TransmitInitError | null => cached;

export const clearTransmitInitError = (): void => {
  cached = null;
};
